import { css, LoadingType, polished } from 'jimu-core';
export const loadingStyles = ({ theme, type }) => {
    return css `
    position: absolute;
    z-index: 2002;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .donut-loading {
      @keyframes donut-spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }

      display: inline-block;
      border: 2px solid ${theme.ref.palette.neutral[500]};
      border-left-color: ${theme.sys.color.primary.main};
      border-radius: 50%;
      position: absolute;
      width: ${polished.rem(32)};
      height: ${polished.rem(32)};
      right: calc(50% - ${polished.rem(16)});
      top: calc(50% - ${polished.rem(16)});
      animation: donut-spin 1.2s linear infinite;
    }
    .bar-loading{
        width: 100%;
        height: 2px;
        overflow: hidden;
        background-color: transparent;
        position: relative;
        :after{
          content: ' ';
          display: inline-block;
          height: 100%;
          width: 25%;
          position: absolute;
          top: 0;
          background-color: ${theme.sys.color.primary.main};
          animation: bar 2.6s linear infinite;
        }
        @keyframes bar{
          0%{
            transform: translateX(-25%);
          }
          25%{
            transform: translateX(175%);
          }
          50%{
            transform: translateX(375%);
          }
          75%{
            transform: translateX(575%);
          }
          100%{
            transform: translateX(775%);
          }
        }
      }
    ${(type === LoadingType.DotsPrimary || type === LoadingType.DotsSecondary) && css `
      display: flex;
      justify-content: center;
      align-items: center;
      @keyframes ball-fall {
        0%{
          opacity: 0;
          transform: translateY(-145%);
        }
        10%{
          opacity: .5;
        }
        20%{
          opacity: 1;
          transform: translateY(0);
        }
        80%{
          opacity: 1;
          transform: translateY(0);
        }
        90%{
          opacity: .5;
        }
        100%{
          opacity: 0;
          transform:translateY(145%);
        }
      }
      &:before,
      &:after,
      .dot-loading {
        width: 0.25rem;
        height: 0.25rem;
        border-radius: 0.25rem;
        box-sizing: border-box;
        opacity:0;
        animation: ball-fall 1s ease-in-out infinite;
      }
      &:before,
      &:after {
        content: '';
        display: inline-block;
      }
      &:before {
        left: -0.375rem;
        animation-delay: -200ms;
      }
      .dot-loading {
        display: inline-block;
        margin: 0 0.125rem;
        animation-delay: -100ms;
      }
      &:after {
        left: 0.375rem;
        animation-delay: 0ms;
      }
      .dot-loading, &:before, &:after {
        background: ${type === LoadingType.DotsPrimary ? theme.sys.color.primary.main : theme.ref.palette.neutral[500]};
      }
    `}
  `;
};
